import { mapRowsBySchema } from '../../../../util';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { M_FinalSign_BASIC_Schema } from './M_FinalSign_BASIC_Schema';
import useSaveMutation from '../../../../Hooks/apis/useSaveMutaion';

/** TBM 참가자 저장 saveTbmNewU2 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_FinalSign_BASIC_Schema.mapper.save1);
    return apiRequest('post1', Global.urls.ToolBoxMeeting.saveTbmNewU2, payload);
  }, options);
};
